module.exports = __webpack_public_path__ + "img/microphone_red.3dd73666.png";